module.exports = __webpack_public_path__ + "static/media/pencil-white.6b74f43e.svg";